import {
  createStyles,
  withStyles,
  IconButton,
  IconButtonProps,
} from '@material-ui/core';
import React from 'react';

const FsIconButton = withStyles(() =>
  createStyles({
    root: {},
  })
)((props: IconButtonProps) => <IconButton {...props} />);

export default FsIconButton;
